const floatToEndingNine = (float: number): number => {
  const mod = (float * 10) % 10
  if (mod === 0 || mod === 5) {
    float -= 0.01
  }
  return float
}

export default floatToEndingNine
